import HeartClipboard from '@assets/icons/heart-clipboard.svg'
import { Icon } from './Icon'

export const HeartClipboardIcon = Icon(HeartClipboard)
